module.exports = __webpack_public_path__ + "img/onboarded-status.57d01c3.png";